import { encryptionSecretKey } from '@/config/Config'
import sanitizeHTML from '@/utilities/SanitizeHTML'
import CryptoJS from 'crypto-js'
import moment from 'moment'
// import { useAuth } from '../context/useAuth'
import { getActiveViews } from '@/utilities/userStore'

export const isLocalhost = () => typeof window !== 'undefined' && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)

// Userback patches console methods, which strips the original call site from
// devtools log line numbers. Keep it off on localhost so local logs stay accurate.
export const isUserbackEnabled = () => Boolean(import.meta.env.VITE_USER_BACK_TOKEN) && !isLocalhost()

export const getFormattedNumber = (value, decimals = 3) => {
  const num = Number(value)

  if (Number.isNaN(num)) return '0'

  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}
export const formatContactName = (name) =>
  name
    ?.split('|')
    .map((part) => part.trim())
    .filter(Boolean)
    .join(' ')

export const joinIfPresent = (separator, ...values) => values.filter((v) => v !== null && v !== undefined && v !== '').join(separator)

export const valueOrDash = (value, dash = '-') => (value === null || value === undefined || value === '' || value === 0 ? dash : value)

export function formatNoCommaCurrency(value, decimals = 3) {
  const num = Number(value)

  if (isNaN(num)) return ''
  return num?.toFixed(decimals)?.replace(/\.?0+$/, '')
}

export const numberWithCommas = (num) => {
  const fixedNumber = Number.parseFloat(num).toFixed(2)
  return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const revenueWithCommas = (num) => {
  const fixedNumber = Number.parseFloat(num).toFixed(0)
  return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const Commaswithdecimal = (num) => {
  const fixedNumber = Number.parseFloat(num).toFixed(3)
  return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const NumbertoFixed = (value, fixedvalue = 0) => {
  const num = parseFloat(value)
  return Number.isNaN(num) ? 0 : Number(num.toFixed(fixedvalue))
}
export const validPrice = (num) => {
  if (typeof num === 'boolean' || num === null || num === undefined) return false
  if (!/^\d+(\.\d+)?$/.test(String(num).trim())) return false
  const number = Number(num)
  return Number.isFinite(number) && number >= 0
}

export const getUTCformat = (date) => moment(date).utc().format('YYYY-MM-DDTHH:mm:ss+00:00')

// convert YYYY-MM-DDT00:00:00 to MM/DD/YY
export const formatDate = (date) =>
  // date = date.split("T")[0].split("-");
  [new Date(date).getMonth() + 1, new Date(date).getDate(), new Date(date).getFullYear().toString().substr(-2)].join('/')
export const getDayFromDate = (date) => new Date(date).toLocaleString('en', { weekday: 'short' })

export const getEmailDateFormat = (date) => {
  const day = getDayFromDate(date)
  // let time = date.split("T")[1].split(":");
  // time = time[0] + ":" + time[1];
  const time = `${new Date(date).getHours() < 10 ? `0${new Date(date).getHours()}` : new Date(date).getHours()}:${
    new Date(date).getMinutes() < 10 ? `0${new Date(date).getMinutes()}` : new Date(date).getMinutes()
  }`
  return [day, formatDate(date), time].join(' ')
}
export const getQuoteCreateDate = (date) =>
  `${new Date(date).getMonth() + 1}/${new Date(date).getDate()}/${new Date(date).getFullYear()} - ${
    new Date(date).getHours() < 10 ? `0${new Date(date).getHours()}` : new Date(date).getHours()
  }:${new Date(date).getMinutes() < 10 ? `0${new Date(date).getMinutes()}` : new Date(date).getMinutes()}`
export const getLocalDateTime = (date) =>
  new Date(
    `${new Date(date).getMonth() + 1}/${new Date(date).getDate()}/${new Date(date).getFullYear()} ${new Date(date).getHours()}:${new Date(
      date
    ).getMinutes()} UTC`
  )

export const checkForDateValue = (title, data) => {
  // console.log(new Date().getFullYear())
  // let data = '3/25/21'
  // console.log(3 / 25, '3/25')
  // if (moment(newdate, 'MM/DD', true).isValid()) {
  //   let formattedDate = moment(`${newdate}/${new Date().getFullYear()}`, 'MM/DD/YYYY').format('MM/DD/YY')
  //   console.log('Valid', formattedDate)
  //   return formattedDate
  // console.log(moment(data, 'MM/DD', true).isValid(), data)

  if (title.toLowerCase().includes('date')) {
    if (data === null || data === undefined || data === '' || data === '-') return data

    if (data instanceof Date) return moment(data).format('MM/DD/YY')

    const value = String(data).trim()
    const parts = value.split('/')

    // Check the number of parts
    if (parts.length === 2) {
      // If there are two parts, it means the year is missing
      // Get the current year
      const currentYear = new Date().getFullYear()
      data = `${parts[0]}/${parts[1]}/${currentYear.toString().slice(-2)}`
      // console.log('validateddate', data)
      // Format the input date with the current year (last two digits)
      return data
    }
  }

  // console.log('Invalid', title)
  if (title.toLowerCase().includes('date')) {
    if (data) {
      const value = String(data).trim()
      const parsedDate = moment(
        value,
        [moment.ISO_8601, moment.RFC_2822, 'M/D/YY', 'MM/DD/YY', 'M/D/YYYY', 'MM/DD/YYYY', 'M-D-YY', 'MM-DD-YY', 'M-D-YYYY', 'MM-DD-YYYY'],
        true
      )

      return parsedDate.isValid() ? parsedDate.format('MM/DD/YY') : data
    }
    // console.log('skipped', title)
    return data
  }
  return data
}

export const checktype = (title) => {
  if (title?.toLowerCase()?.includes('date')) {
    return '--/--/----'
  }
  return '--No value--'
}

export const datediff = (lppdate) => {
  if (lppdate != null) {
    const givenDate = new Date(lppdate)
    // Current date
    const currentDate = new Date()

    // Calculate the difference in milliseconds
    const differenceInMillis = currentDate - givenDate

    // Convert milliseconds to days
    const differenceInDays = differenceInMillis / (1000 * 60 * 60 * 24)
    const datediffvalue = differenceInDays.toFixed()
    // console.log(datediffvalue)
    return datediffvalue
  }
}

export const encryptData = (text) => {
  if (text != null) {
    const data = CryptoJS.AES.encrypt(JSON.stringify(text), encryptionSecretKey).toString()
    return data
  }
  return null
}

export const decryptData = (text) => {
  if (text != null) {
    const bytes = CryptoJS.AES.decrypt(text, encryptionSecretKey)
    const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    return data
  }
  return null
}

export const currentUserRolesScopes = () => {
  // const { activeViews } = useAuth()
  const activeViews = getActiveViews()
  // console.log(activeViews)
  return activeViews
}

export const ValidateEmail = (email) => {
  const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  if (email.match(mailformat)) {
    return true
  }
  return false
}

export const ValidateNumber = (number) => /^\d+$/.test(number)

export const trimFileName = (name) => {
  if (!name || typeof name !== 'string') return name

  return name.indexOf('___') !== -1 ? `${name.split('___')[0]}.${name.split('.').at(-1)}` : name
}

export const trimFileNameV2 = (name) => {
  // Handle null, undefined, or empty string
  if (!name || typeof name !== 'string') {
    return name
  }

  if (name.indexOf('___') === -1) {
    return name
  }

  // Split the extension off first so the stamps are matched against bare segments and the
  // extension is re-attached exactly once.
  const dot = name.lastIndexOf('.')
  const suffix = dot > 0 ? name.slice(dot) : ''
  const parts = name.slice(0, dot > 0 ? dot : undefined).split('___')

  // A re-uploaded file is stamped again on top of its old stamp, so the name can carry
  // several `<datetime>___<uuid>` pairs. Peel them off one pair at a time — matching the
  // stamp shape rather than counting segments, so a base name that happens to contain
  // `___` survives untouched.
  const STAMP_DATETIME = /^\d{8}_\d{6}$/
  const STAMP_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

  while (parts.length > 2 && STAMP_DATETIME.test(parts.at(-2)) && STAMP_UUID.test(parts.at(-1))) {
    parts.splice(-2)
  }

  return `${parts.join('___')}${suffix}`
}

export function setCookie(name, value, days) {
  let expires = ''
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`
}
export function getCookie(name) {
  let nameEQ = `${name}=`
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}
export function eraseCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const saveDataToLocal = (key, value) => {
  sessionStorage.setItem(key, value)
}

export const retriveDataFromLocal = (key) => {
  return sessionStorage.getItem(key)
}

export const removeDataFromLocal = (key) => {
  sessionStorage.removeItem(key)
}

export const removeAllDataFromLocal = () => {
  sessionStorage.clear()
}

const mimeTypes = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  png: 'image/png',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}

export const createFileUrl = (contentBytes, ext) => {
  if (!contentBytes) {
    console.error('No file content available!')
    return null
  }

  const base64Data = contentBytes.replace(/^data:.*;base64,/, '')

  const binaryString = atob(base64Data)
  const byteArray = new Uint8Array(binaryString.length)

  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i)
  }

  const mimeType = mimeTypes[ext] || 'application/octet-stream'
  const blob = new Blob([byteArray], { type: mimeType })
  const url = URL.createObjectURL(blob)

  return url
}

export function getDisplayDate(datetime) {
  if (!datetime) return '-'

  const date = new Date(datetime)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  const isSameDay = (d1, d2) => d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()

  if (isSameDay(date, today)) {
    let hours = date.getHours()
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12
    return `${hours}:${minutes} ${ampm}`
  }
  if (isSameDay(date, yesterday)) return 'Yesterday'

  // Fallback: MM/DD/YYYY
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const yyyy = date.getFullYear()

  return `${mm}/${dd}/${yyyy}`
}

export function allowAlphabetsOnly(e, allowSpaces = true) {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Control', 'Meta', 'Shift', 'Alt', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

  const isModifierKey = allowedKeys.includes(e.key)
  const isCutCopyPaste = (e.ctrlKey || e.metaKey) && ['x', 'c', 'v'].includes(e.key.toLowerCase())
  const isAlphabet = /^[a-zA-Z]$/.test(e.key)

  // Check for space and prevent consecutive spaces
  const isSpace = allowSpaces && e.key === ' '
  const hasPreviousSpace = isSpace && e.target.selectionStart > 0 && e.target.value.charAt(e.target.selectionStart - 1) === ' '

  if (!isAlphabet && !(isSpace && !hasPreviousSpace) && !isModifierKey && !isCutCopyPaste) {
    e.preventDefault()
  }
}

export const allowOnlyNumbersAndDot = (e) => {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Control', 'Meta', 'Shift', 'Alt', 'ArrowLeft', 'ArrowRight', 'Home', 'End']
  const isCutCopyPaste = (e.ctrlKey || e.metaKey) && ['a', 'x', 'c', 'v'].includes(e.key.toLowerCase())
  if (isCutCopyPaste || allowedKeys.includes(e.key) || (e.key === '.' && !e.target.value.includes('.')) || /^[0-9]$/.test(e.key)) {
    return
  }

  e.preventDefault()
}

export function allowNumbersOnly(e) {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Control', 'Meta', 'Shift', 'Alt', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

  const isModifierKey = allowedKeys.includes(e.key)
  const isCutCopyPaste = (e.ctrlKey || e.metaKey) && ['a', 'x', 'c', 'v'].includes(e.key.toLowerCase())
  const isNumber = /^[0-9]$/.test(e.key)

  if (!isNumber && !isModifierKey && !isCutCopyPaste) {
    e.preventDefault()
  }
}

export function allowAlphanumericSpaceOnly(e) {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Control', 'Meta', 'Shift', 'Alt', 'ArrowLeft', 'ArrowRight', 'Home', 'End', ' ']

  const isModifierKey = allowedKeys.includes(e.key)
  const isCutCopyPaste = (e.ctrlKey || e.metaKey) && ['a', 'x', 'c', 'v'].includes(e.key.toLowerCase())
  const isAlphanumeric = /^[a-zA-Z0-9]$/.test(e.key)

  if (!isAlphanumeric && !isModifierKey && !isCutCopyPaste) {
    e.preventDefault()
  }
}

export function allowAlphanumericOnly(e) {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Control', 'Meta', 'Shift', 'Alt', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

  const isModifierKey = allowedKeys.includes(e.key)
  const isCutCopyPaste = (e.ctrlKey || e.metaKey) && ['a', 'x', 'c', 'v'].includes(e.key.toLowerCase())
  const isAlphanumeric = /^[a-zA-Z0-9]$/.test(e.key)

  if (!isAlphanumeric && !isModifierKey && !isCutCopyPaste) {
    e.preventDefault()
  }
}

export const hasKeyInData = (data, key) => {
  return data && Object.prototype.hasOwnProperty.call(data, key)
}
export const getChangedValues = (obj1, obj2) => {
  const changedValues = {}

  // Get all keys that exist in both objects
  const commonKeys = Object.keys(obj1).filter((key) => key in obj2)

  for (const key of commonKeys) {
    const val1 = obj1[key]
    const val2 = obj2[key]

    // Skip if both values are null/undefined
    if (val1 == null && val2 == null) continue

    // Special handling for email arrays
    if (key === 'email' && Array.isArray(val1)) {
      const emailsDiffer = val1.length !== val2?.length || !val1.every((email, index) => email === val2[index])

      if (emailsDiffer) {
        changedValues[key] = [...val1] // Return original email array from obj1
      }
    }
    // Handle regular arrays (non-email)
    else if (Array.isArray(val1) && Array.isArray(val2)) {
      if (val1.length !== val2.length || !val1.every((item, i) => item === val2[i])) {
        // if (val2 != null) {
        changedValues[key] = val1
        // }
      }
    }
    // Handle primitive values
    else if (val1 !== val2) {
      // if (val2 != null) {
      changedValues[key] = val1
      // }
    }
  }

  return Object.keys(changedValues).length ? changedValues : null
}

export function isBlank(value) {
  return value == null || String(value).trim().length === 0
}

export function formatphone(digits) {
  let formatted = ''
  try {
    if (digits.includes('-')) {
      digits = digits.replace(/\D/g, '')
    }
    if (!digits || digits === undefined || digits.length === 0) {
      formatted = ''
    } else if (digits.startsWith('1') && digits.length > 1) {
      // Format as international: 1-XXX-XXX-XXXX
      const country = digits[0]
      const area = digits.slice(1, 4)
      const mid = digits.slice(4, 7)
      const last = digits.slice(7, 11)

      if (digits.length >= 11) {
        formatted = `${country}-${area}-${mid}-${last}`
      } else if (digits.length >= 8) {
        formatted = `${country}-${area}-${mid}-${digits.slice(7)}`
      } else if (digits.length >= 5) {
        formatted = `${country}-${area}-${digits.slice(4)}`
      } else if (digits.length >= 2) {
        formatted = `${country}-${digits.slice(1)}`
      } else {
        formatted = country
      }
    } else {
      // Format as domestic: XXX-XXX-XXXX
      const area = digits.slice(0, 3)
      const mid = digits.slice(3, 6)
      const last = digits.slice(6, 10)

      if (digits.length === 10) {
        formatted = `${area}-${mid}-${last}`
      } else {
        formatted = digits
      }
    }
  } catch (error) {
    console.log(error, formatted)
  }
  return formatted
}

export function applyQueryPaste(rows, startIndex, targetItems, setQuickTabItems) {
  const newItems = [...targetItems]

  rows.forEach((row, i) => {
    const currentIndex = startIndex + i
    if (currentIndex < newItems.length) {
      const item = { ...newItems[currentIndex] }
      item.query = row.trim() // full line as query
      newItems[currentIndex] = item
    }
  })

  setQuickTabItems(newItems)
}

export function applyPastedData(rows, startIndex, targetItems, setQuickTabItems) {
  const newItems = [...targetItems]

  rows.forEach((row, i) => {
    const cols = row.split('\t')
    const currentIndex = startIndex + i

    if (currentIndex < newItems.length) {
      const item = { ...newItems[currentIndex] }

      // Quantity - keep digits and "x" (e.g. "2x50"), drop everything else
      if (cols[0] !== undefined) {
        const qty = cols[0].replace(/[^0-9xX]/g, '')
        if (qty) {
          item.quantity = /[xX]/.test(qty) ? qty : parseInt(qty, 10)
        }
      }

      // Query
      if (cols.length > 1) {
        item.query = cols.slice(1).join(' ').trim()
      } else if (cols[1] !== undefined) {
        item.query = cols[1].trim()
      }

      newItems[currentIndex] = item
    }
  })

  setQuickTabItems(newItems)
}

export const isDateBeforeToday = (dateString, format = 'MM/DD/YYYY') => {
  if (!dateString && !dateString?.length > 0) {
    return false
  }

  let [month, day, year] = dateString.split('/').map(Number)
  if (year < 100) year += 2000
  const inputDate = new Date(year, month - 1, day)
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return inputDate < today
}

function decodeHTMLEntities(text) {
  const parser = new DOMParser()
  return parser.parseFromString(text, 'text/html').documentElement.textContent
}

// Get only direct text content (exclude nested XML)
function getDirectText(node) {
  return Array.from(node.childNodes)
    .filter((child) => child.nodeType === Node.TEXT_NODE)
    .map((child) => child.nodeValue.trim())
    .filter(Boolean)
    .join(' ')
}

// Recursive parser for <ImportMessage>
function extractMessages(node) {
  const results = []

  if (node.nodeName === 'ImportMessage') {
    const text = getDirectText(node)
    if (text) {
      results.push({
        severity: node.getAttribute('severity') || 'info',
        text
      })
    }
  }

  // Recurse into children
  for (const child of node.children) {
    results.push(...extractMessages(child))
  }

  return results
}

export function parseResponseMessage(raw) {
  if (!raw) return []

  const decoded = decodeHTMLEntities(raw)

  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(decoded, 'application/xml')

  // Fallback: plain text (not XML)
  if (xmlDoc.getElementsByTagName('parsererror').length > 0) {
    return decoded
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => ({ severity: 'error', text: line }))
  }

  // Extract all ImportMessage nodes recursively
  const root = xmlDoc.documentElement
  const messages = extractMessages(root)

  return messages.length > 0 ? messages : [{ severity: 'info', text: decoded }]
}

// erp_error often has a valid <ImportReturn>...</ImportReturn> XML body followed by
// an unrelated .NET stack trace tail (e.g. "</ImportReturn> (-8)\n   at P21...").
// Trim to the XML body before parsing so the stack trace doesn't get treated as text.
export function formatErpError(raw) {
  if (!raw) return ''

  const rootMatch = raw.match(/<([A-Za-z_][\w.-]*)[ >]/)
  let xmlPortion = raw
  if (rootMatch) {
    const closeTag = `</${rootMatch[1]}>`
    const lastClose = raw.lastIndexOf(closeTag)
    if (lastClose !== -1) {
      xmlPortion = raw.slice(0, lastClose + closeTag.length)
    }
  }

  const messages = parseResponseMessage(xmlPortion)
  const errorMessages = messages.filter((m) => m.severity === 'error')
  const chosen = errorMessages.length > 0 ? errorMessages : messages

  return chosen.map((m) => m.text.trim().replace(/\.$/, '')).join('\n')
}

export const isMOQInvalid = (qty, minQty) => {
  const q = Number(qty) || 0
  const m = Number(minQty) || 0

  // if (m <= 0) return false // if no MOQ, skip validation
  // if no MOQ but qty = 0 → invalid
  if (m <= 0) {
    return q === 0
  }

  return q === 0 || q < m || q % m !== 0
}

export function debounce(func, delay) {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), delay)
  }
}

export function addMarginToParagraphs(html) {
  const div = document.createElement('div')
  div.innerHTML = html

  const paragraphs = div.querySelectorAll('p')
  paragraphs.forEach((p) => {
    p.style.margin = '0'
  })

  return div.innerHTML
}

async function measureAsyncFunction(fn, ...args) {
  const start = performance.now()
  const result = await fn(...args)
  const end = performance.now()
  const duration = end - start

  return {
    result,
    duration,
    durationMs: duration,
    durationSeconds: duration / 1000
  }
}

async function myAsyncFunction() {
  await new Promise((resolve) => setTimeout(resolve, 1000))
  return 'Done!'
}
// measureAsyncFunction(myAsyncFunction)
//     .then(({ result, durationMs }) => {
//         console.log(`Function completed in ${durationMs}ms with result: ${result}`);
//     });

export function htmlToPlainText(html, options = {}) {
  const defaults = {
    preserveLinks: false,
    preserveImages: false,
    lineBreaks: true,
    whitespace: 'normalize'
  }

  const config = { ...defaults, ...options }

  if (!html) return ''

  // Sanitize before ever assigning to innerHTML: browsers resolve/execute
  // event-handler attributes (onerror, onload, etc.) on elements like <img>/<svg>
  // as soon as they're parsed, even on a detached node, so untrusted markup
  // must never reach innerHTML unsanitized.
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = sanitizeHTML(html)

  // Process specific elements
  const elements = tempDiv.querySelectorAll('*')
  elements.forEach((el) => {
    const tagName = el.tagName

    switch (tagName) {
      case 'BR':
        el.replaceWith('\n')
        break
      case 'P':
      case 'DIV':
        if (config.lineBreaks) {
          el.innerHTML = '\n' + el.innerHTML + '\n'
        }
        break
      case 'A':
        if (config.preserveLinks) {
          const href = el.getAttribute('href')
          if (href) {
            el.textContent = `${el.textContent} [${href}]`
          }
        }
        break
      case 'IMG':
        if (config.preserveImages) {
          const alt = el.getAttribute('alt') || 'Image'
          el.replaceWith(`[${alt}]`)
        } else {
          el.remove()
        }
        break
      case 'SCRIPT':
      case 'STYLE':
      case 'NOSCRIPT':
        el.remove()
        break
    }
  })

  let text = tempDiv.textContent || tempDiv.innerText || ''

  // Clean up whitespace based on configuration
  switch (config.whitespace) {
    case 'preserve':
      break
    case 'normalize':
      text = text.replace(/\s+/g, ' ')
      break
    case 'collapse':
      text = text.replace(/\s+/g, ' ').trim()
      break
  }

  // Clean up multiple newlines
  if (config.lineBreaks) {
    text = text.replace(/\n\s*\n/g, '\n\n')
  }

  return text.trim()
}

// helper to detect base64 and build data URL; MIME fallback to image/png
export function buildDataUrl(base64, mime = 'image/png') {
  return `data:${mime};base64,${base64}`
}

// main replacer: returns sanitized/updated HTML string
export function replaceCidImagesInHtml(bodyHtml = '', attachments = []) {
  if (!bodyHtml || !attachments || !attachments.length) return bodyHtml

  // Create a map from content_id (normalized) -> attachment
  const map = new Map()
  attachments.forEach((att) => {
    if (!att?.content_id) return
    // normalize: some CIDs are wrapped in <>, or have "cid:" prefix, so keep raw content_id
    map.set(att.content_id, att)
    // also map variations without surrounding <> for robustness
    map.set(att.content_id.replace(/^<|>$/g, ''), att)
  })

  // parse HTML in a DOMParser (works in browser)
  const parser = new DOMParser()
  const doc = parser.parseFromString(bodyHtml, 'text/html')

  // find all <img> elements whose src starts with "cid:"
  const imgs = Array.from(doc.querySelectorAll('img[src^="cid:"], img[src*="cid:"]'))
  imgs.forEach((img) => {
    const src = img.getAttribute('src') || ''
    // extract the cid identifier after cid:
    const cid = src.split('cid:').pop()
    if (!cid) return

    // try direct match and also try with/without angle brackets
    const att = map.get(cid) || map.get(`<${cid}>`)
    if (!att) return

    // determine base64 content and mime type
    const contentBase64 = att.content_bytes || att.content || att.contentBytes // accept common keys
    if (!contentBase64) return

    // If attachment includes a content_type or mime, use it
    const mime = att.content_type || att.mime || att.contentType || 'image/png'

    // build data URL and set as src
    const dataUrl = buildDataUrl(contentBase64, mime)
    img.setAttribute('src', dataUrl)

    // Optionally add alt or data- attributes to indicate replaced
    img.setAttribute('data-replaced-cid', cid)
  })

  // serialize back to HTML fragment (return innerHTML of body)
  return doc.body.innerHTML
}

export const reduceHexOpacity = (hex, opacity) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

// True when the quote's payment terms (id or name) differ from the customer's default payment terms.
// Compares trimmed, uppercased, whitespace-collapsed values; returns false when either side is missing.
export const isPaymentTermsMismatched = (customerTerms, quoteTerms) => {
  const normalize = (value) => (value == null ? '' : String(value).trim().toUpperCase().replace(/\s+/g, ' '))
  const customer = normalize(customerTerms)
  const quote = normalize(quoteTerms)
  return !!customer && !!quote && customer !== quote
}

// True when the order's freight account differs from the ship-to's freight account.
// Reuses the payment-terms comparison so both overrides share the same normalisation and
// "both sides filled" rule — false when either account is blank.
export const isFreightAccountMismatched = (shiptoAccount, headerAccount) => isPaymentTermsMismatched(shiptoAccount, headerAccount)
